import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            {
                label: 'Bundle',
                value: 'bundle',
            },
            {
                label: 'email',
                value: 'email',
            },
            {
                label: 'f5haber',
                value: 'f5haber',
            },
            {
                label: 'facebook',
                value: 'facebook',
            },
            {
                label: 'haberler.com',
                value: 'haberler.com',
            },
            {
                label: 'gazetekeyfi',
                value: 'gazetekeyfi',
            },
            {
                label: 'gazeteoku',
                value: 'gazeteoku',
            },
            {
                label: 'google',
                value: 'google',
            },
            {
                label: 'guncelhaberler',
                value: 'guncelhaberler',
            },
            {
                label: 'webpush',
                value: 'webpush',
            },
            {
                label: 't.co',
                value: 't.co',
            },
            {
                label: 'taboola',
                value: 'taboola',
            },
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            {
                label: 'Bundle',
                value: 'bundle',
            },
            {
                label: 'email',
                value: 'email',
            },
            {
                label: 'f5haber',
                value: 'f5haber',
            },
            {
                label: 'facebook',
                value: 'facebook',
            },
            {
                label: 'haberler.com',
                value: 'haberler.com',
            },
            {
                label: 'gazetekeyfi',
                value: 'gazetekeyfi',
            },
            {
                label: 'gazeteoku',
                value: 'gazeteoku',
            },
            {
                label: 'google',
                value: 'google',
            },
            {
                label: 'guncelhaberler',
                value: 'guncelhaberler',
            },
            {
                label: 'webpush',
                value: 'webpush',
            },
            {
                label: 't.co',
                value: 't.co',
            },
            {
                label: 'taboola',
                value: 'taboola',
            },
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Gündem', value: 'gündem' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Kelebek', value: 'kelebek' },
            { label: 'Yaşam', value: 'yaşam' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Spor', value: 'spor' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Cumartesi', value: 'cumartesi' },
            { label: 'Pazar', value: 'pazar' },
            { label: 'Seyahat', value: 'seyahat' },
            { label: 'Eğitim', value: 'eğitim' },
            { label: 'Astroloji', value: 'astroloji' },
            { label: 'Bigpara', value: 'bigpara' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Ahmet Hakan', value: 'ahmet hakan' },
            { label: 'Abdulkadir Selvi', value: 'abdulkadir selvi' },
            { label: 'Aygül Aydın', value: 'aygul aydin' },
            { label: 'Barbaros Tapan', value: 'barbaros tapan' },
            { label: 'Deniz Sipahi', value: 'deniz sipahi' },
            { label: 'Dinçer Güner', value: 'dincer guner' },
            { label: 'Fatih Çekirge', value: 'fatih çekirge' },
            { label: 'Fuat Bol', value: 'fuat bol' },
            { label: 'Fulya Soybaş', value: 'fulya soybaş' },
            { label: 'İhsan Yılmaz', value: 'ihsan yilmaz' },
            { label: 'Mehmet Üstündağ', value: 'mehmet ustundag' },
            { label: 'Mehmet Soysal', value: 'mehmet soysal' },
            { label: 'Nedim Şener', value: 'nedim sener' },
            { label: 'Noyan Doğan', value: 'noyan dogan' },
            { label: 'Onur Başturk', value: 'onur başturk' },
            { label: 'Osman Müftüoğlu', value: 'osman muftuoglu' },
            { label: 'Savaş Özbey', value: 'savas ozbey' },
            { label: 'Salim Uzun', value: 'salim uzun' },
            { label: 'Sefer Levent', value: 'sefer levent' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'ademircubuk', value: 'ademircubuk' },
            { label: 'aegumus', value: 'aegumus' },
            { label: 'agcetin', value: 'agcetin' },
            { label: 'andemir', value: 'andemir' },
            { label: 'aoaydin', value: 'aoaydin' },
            { label: 'aydin', value: 'aydin' },
            { label: 'Aysel ALP', value: 'aysel alp' },
            { label: 'bakin', value: 'bakin' },
            { label: 'batesli', value: 'batesli' },
            { label: 'bkaya', value: 'bkaya' },
            { label: 'bozel', value: 'bozel' },
            { label: 'bozkan', value: 'bozkan' },
            { label: 'bsahbaz', value: 'bsahbaz' },
            { label: 'btasci', value: 'btasci' },
            { label: 'Burak TAŞÇI', value: 'burak taşçi' },
            { label: 'cgelgec', value: 'cgelgec' },
            { label: 'cizmitli', value: 'cizmitli' },
            { label: 'ckoncu', value: 'ckoncu' },
            { label: 'cyaman', value: 'cyaman' },
            { label: 'dayas', value: 'dayas' },
            { label: 'degirmenci', value: 'degirmenci' },
            { label: 'edanur.sengul', value: 'edanur.sengul' },
            { label: 'edogan', value: 'edogan' },
            { label: 'egemen.yildirim', value: 'egemen.yildirim' },
            { label: 'egtopcular', value: 'egtopcular' },
            { label: 'elif', value: 'elif' },
            { label: 'eokutan', value: 'eokutan' },
            { label: 'etasci', value: 'etasci' },
            { label: 'eunal', value: 'eunal' },
            { label: 'fatici', value: 'fatici' },
            { label: 'fayaz', value: 'fayaz' },
            { label: 'fgider', value: 'fgider' },
            { label: 'Fuat iğci', value: 'fuat.igci' },
            { label: 'fzozdemir', value: 'fzozdemir' },
            { label: 'gcavdarci', value: 'gcavdarci' },
            { label: 'gdemirel', value: 'gdemirel' },
            { label: 'ghatunoglu', value: 'ghatunoglu' },
            { label: 'grpanaliz', value: 'grpanaliz' },
            { label: 'Gülistan ALAGÖZ', value: 'gulistan alagoz' },
            { label: 'Gürer Mut', value: 'gürer mut' },
            { label: 'hakanalkan', value: 'hakanalkan' },
            { label: 'Harun Elibol', value: 'harun elibol' },
            { label: 'hsoyoz', value: 'hsoyoz' },
            { label: 'Hüseyin ÇAKMAK', value: 'huseyin cakmak' },
            { label: 'icerik', value: 'icerik' },
            { label: 'ikibar', value: 'ikibar' },
            { label: 'İlker Kocaş', value: 'i̇lker kocaş' },
            { label: 'imza', value: 'imza' },
            { label: 'isari', value: 'isari' },
            { label: 'kataer', value: 'kataer' },
            { label: 'kelebekstajer', value: 'kelebekstajer' },
            { label: 'Kubilay Aydın', value: 'kubilay.aydin' },
            { label: 'lsert', value: 'lsert' },
            { label: 'mehmet hazar gönüllü', value: 'mehmet hazar gonullu' },
            { label: 'mkahraman', value: 'mkahraman' },
            { label: 'msusut', value: 'msusut' },
            { label: 'Muhammed Karabulut', value: 'mkarabulut' },
            { label: 'muratyilmaz', value: 'muratyilmaz' },
            { label: 'nasilkolay', value: 'nasilkolay' },
            { label: 'Nerdun HACIOĞLU', value: 'nerdun hacioglu' },
            { label: 'nmengu', value: 'nmengu' },
            { label: 'ntomrukcu', value: 'ntomrukcu' },
            { label: 'ohasancebioglu', value: 'ohasancebioglu' },
            { label: 'Onur Karademir', value: 'okarademir' },
            { label: 'oisik', value: 'oisik' },
            { label: 'okilic', value: 'okilic' },
            { label: 'oozturk', value: 'oozturk' },
            { label: 'oyagmur', value: 'oyagmur' },
            { label: 'oyenilmez', value: 'oyenilmez' },
            { label: 'Ömer ERBİL', value: 'omer erbi̇l' },
            { label: 'Önder ÖNDEŞ', value: 'onder ondes' },
            { label: 'Özge EĞRİKAR', value: 'ozge egri̇kar' },
            { label: 'pyaman', value: 'pyaman' },
            { label: 'Savaş ÖZBEY', value: 'savaş ozbey' },
            { label: 'sdinc', value: 'sdinc' },
            { label: 'Sedef Batı', value: 'sedef bati' },
            { label: 'Selim ÖZTÜRK', value: 'selim ozturk' },
            { label: 'Selin Irmak KAÇMAZ', value: 'selin irmak kacmaz' },
            { label: 'Sevin Turan', value: 'sevin turan' },
            { label: 'sicen', value: 'sicen' },
            { label: 'Sinem Vural', value: 'sinem vural' },
            { label: 'sistem', value: 'sistem' },
            { label: 'spulluk', value: 'spulluk' },
            { label: 'stajyer1', value: 'stajyer1' },
            { label: 'stajyerseo', value: 'stajyerseo' },
            { label: 'sturan', value: 'sturan' },
            { label: 'suygun', value: 'suygun' },
            { label: 'taslan', value: 'taslan' },
            { label: 'tayibe.onel', value: 'tayibe.onel' },
            { label: 'tcay', value: 'tcay' },
            { label: 'Tuğba Öztürk', value: 'tugba ozturk' },
            { label: 'Tülay DEMİR', value: 'tulay demi̇r' },
            { label: 'Uğur ERGAN', value: 'ugur ergan' },
            { label: 'Umut ERDEM', value: 'umut erdem' },
            { label: 'vaslan', value: 'vaslan' },
            { label: 'ykarabulut', value: 'ykarabulut' },
            { label: 'ykocal', value: 'ykocal' },
            { label: 'Yücel Sönmez', value: 'yucel sonmez' },
            { label: 'zatagun', value: 'zatagun' },
            { label: 'zguclucan', value: 'zguclucan' },
            { label: 'zozturk', value: 'zozturk' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterHurriyetcomObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
